<div
  class="card standalone fade configure-passkey-component"
  [ngClass]="{
    'show': isReady()
  }"
>
  <h1
    class="card-header text-center"
  >
    {{'configure-passkey.title'|translate}}
  </h1>
  <div class="card-body">
    <p>{{'configure-passkey.info'|translate}}</p>
    <fieldset
      *ngIf="passKeyForm"
      [formGroup]="passKeyForm"
    >
      <ul *ngFor="let p of passkeys; index as i"  class="list-unstyled">
        <li>
          <div
            app-form-input
            field="{{'pk_' + i}}"
            label="{{'configure-passkey.passkey.label'|translate}}"
            readonly
            [append]="passkey_append"
            [prepend]="passkey_prepend"
          >
            <ng-template #passkey_prepend>
              <span [className]="'icon input-group-text bg-success'">
                <span class="passkey-icon"></span>
              </span>
            </ng-template>
            <ng-template #passkey_append>
              <button
                type="button"
                class="btn btn-danger"
                [disabled]="isUsedAsAuthentication(p.id)"
                (click)="deletePasskey(p.id)"
                [ngbTooltip]="isUsedAsAuthentication(p.id) ? ('configure-passkey.delete-button.disabled-tooltip'|translate) : ('configure-passkey.delete-button.tooltip'|translate)"
              >
                <span class="icon fa fa-fw fa-trash-alt"></span>
                <span class="no-icon">
                  {{'configure-passkey.delete-button.label'|translate}}
                </span>
              </button>
            </ng-template>
          </div>
        </li>
      </ul>
    </fieldset>
    <div class="add-passkey">
      <h4 *ngIf="!!passkeyRegisterActive" class="text-center">{{'configure-passkey.waiting-for-passkey'|translate}}</h4>
      <div *ngIf="!!passkeyRegisterActive" class="loader-wrapper position-relative d-block mb-2">
        <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </div>
      <button
        *ngIf="!passkeyRegisterActive"
        class="btn btn-block btn-lg btn-auto"
        type="button"
        (click)="startPasskeyRegister()"
      >{{'configure-passkey.add-button.label'|translate}}</button>
    </div>
    <app-duke-alert
      type="danger"
      *ngIf="hasError()"
      alertClass="mb-0"
      dismissible="true"
      (open)="alertHandler.onOpen($event);"
      (close)="alertHandler.onClose($event);"
    >
      <p class="mb-0" *ngIf="passkeyError && passkeyError.name === 'InvalidStateError' ">
        {{'configure-passkey.error.already-added-message'|translate}}
      </p>
      <p class="mb-0" *ngIf="!passkeyError || passkeyError.name !== 'InvalidStateError' ">
        {{'configure-passkey.error.message'|translate}}
      </p>
    </app-duke-alert>
  </div>
  <div class="card-footer">
    <div class="d-flex align-items-center flex-row-reverse">
        <a
          [routerLink]="getAppConstant('PATH_EDIT_PROFILE')"
          fragment="login"
          queryParamsHandling="merge"
          class="btn btn-primary"
        >
          {{'configure-passkey.close-button.label'|translate}}
        </a>
      </div>
    </div>
</div>
